import type { StudioCatalog, StudioDefinition, StudioOption } from 'src/components/star-grid/reportStudio.types';
export const studioDeckOptions = (catalog: StudioCatalog, definition: StudioDefinition): StudioOption[] => {
  const existing = Object.keys(definition.decks);
  return (catalog.deck_types ?? existing).map((label) => ({
    id: existing.find((id) => id.toLowerCase() === label.toLowerCase()) ?? label,
    label
  }));
};
